// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3ekcS","header":"MergedInvoice_header__3BAeO"};